import ColumnWidthPropType from './ColumnWidth';
import GBColorPropType from './GBColor';
import NavBarPropType from './ConsumerWeb/NavBar';
import NavLinkPropType from './ConsumerWeb/NavLink';
import FooterPropType from './ConsumerWeb/Footer';
export var PropTypes = {
  ColumnWidthPropType: ColumnWidthPropType,
  GBColorPropType: GBColorPropType,
  NavBarPropType: NavBarPropType,
  NavLinkPropType: NavLinkPropType,
  FooterPropType: FooterPropType
};